
<div>
  <video controls controlsList="nodownload" (contextmenu)="$event.preventDefault()" width="300" height="300">
    <source src="{{data.videoLocation}}" type="video/mp4">
  </video>
</div>
  <div style="width:100%; text-align:right; ">
    <button mat-raised-button (click)="dialogRef.close('ok')" color="primary" style="color: white; background: maroon;">Close</button>
  </div>
